var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmarthome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297 297",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 297 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m294.322,129.817l-140.256-126.371c-3.079-2.775-7.757-2.777-10.838-0.006l-140.543,126.371c-2.495,2.244-3.35,5.791-2.147,8.924 1.201,3.133 4.208,5.201 7.563,5.201h23.944l111.125-98.928c3.098-2.838 7.85-2.84 10.947,0l111.117,98.928h23.664c3.354,0 6.36-2.066 7.562-5.197 1.204-3.131 0.353-6.678-2.138-8.922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.077,156.721v130.816c0,4.473 3.627,8.1 8.101,8.1h196.929c4.474,0 8.101-3.627 8.101-8.1v-130.816l-106.564-94.752-106.567,94.752zm125.632-10.754c2.448-3.744 7.467-4.797 11.212-2.35 15.745,10.287 25.145,27.646 25.145,46.438 0,30.58-24.858,55.459-55.412,55.459-30.549,0-55.402-24.879-55.402-55.459 0-18.789 9.399-36.15 25.145-46.438 3.744-2.447 8.765-1.395 11.212,2.35 2.448,3.744 1.395,8.766-2.351,11.213-11.148,7.285-17.804,19.574-17.804,32.875 0,21.646 17.585,39.258 39.2,39.258 21.62,0 39.21-17.611 39.21-39.258 0-13.301-6.655-25.59-17.805-32.875-3.745-2.447-4.798-7.466-2.35-11.213zm-10.954-3.267v47.355c0,4.473-3.627,8.1-8.101,8.1s-8.101-3.627-8.101-8.1v-47.355c0-4.475 3.627-8.102 8.101-8.102s8.101,3.627 8.101,8.102z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmarthome);
export default __webpack_public_path__ + "static/media/smarthome.9a09cbc195d3791c59bb83b9d8f1e78d.svg";
export { ForwardRef as ReactComponent };